/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./required-asterisk.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var requiredIndicatorStyles = null;
export default function RequiredAsterisk() {
  return /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true",
    title: "required",
    className: ax(["_syaz1ick _ect41gqc _bozgv77o"])
  }, "*");
}